module.exports = __webpack_public_path__ + "static/media/koryu_00009.78a6f041.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/koryu_00009.png
// module id = 262
// module chunks = 0